var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14575 9.99992C2.14575 5.66218 5.66218 2.14575 9.99992 2.14575C14.3377 2.14575 17.8541 5.66218 17.8541 9.99992C17.8541 14.3377 14.3377 17.8541 9.99992 17.8541C5.66218 17.8541 2.14575 14.3377 2.14575 9.99992ZM9.99992 0.145752C4.55761 0.145752 0.145752 4.55761 0.145752 9.99992C0.145752 15.4422 4.55761 19.8541 9.99992 19.8541C15.4422 19.8541 19.8541 15.4422 19.8541 9.99992C19.8541 4.55761 15.4422 0.145752 9.99992 0.145752ZM10.9999 4.68746C10.9999 4.13517 10.5522 3.68746 9.99995 3.68746C9.44766 3.68746 8.99995 4.13517 8.99995 4.68746V10.1522V10.1525C9.0001 10.8872 9.29209 11.5918 9.81169 12.1113L9.8118 12.1114L11.9491 14.2487C12.3396 14.6393 12.9728 14.6393 13.3633 14.2487C13.7538 13.8582 13.7538 13.225 13.3633 12.8345L11.2259 10.6971L11.2258 10.697C11.0813 10.5525 11 10.3566 10.9999 10.1522V10.152V4.68746Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourIcon);
export default __webpack_public_path__ + "static/media/hourIcon.796c572487be539ab45deb57e46ab8dd.svg";
export { ForwardRef as ReactComponent };